import BaseModelProgram from "@/models/BaseModelProgram.js";

export const ProgramInfoGridConfig = {
	list: BaseModelProgram.list,
	columns: BaseModelProgram.columns,
	grid: {
		gridId: 'programGrid',
		height: 500,
		checkbox: true,
		edit: true,
		delete: false,
		document: true,
		groupable: true,
	}
}

export const ProgramInfoToolbarConfig = {
	list: 'ToolBarItems',
	items: [
		{
			id: "btnAddProgram",
			type: "button",
			text: "Add Program",
			showIcon: "toolbar",
			icon: "plus-circle",
			attributes: { "class": "float-right-btn btn btn-primary" }
		},
		{
			id: "btnImportProgram",
			type: "button",
			text: "Import Program",
			showIcon: "toolbar",
			icon: "upload",
			attributes: { "class": "float-right-btn btn btn-secondary" }
		},
		{
			id: "btnDownloadProgramTemplate",
			type: "button",
			text: "Download Template",
			showIcon: "toolbar",
			icon: "download",
			attributes: { "class": "float-right-btn btn btn-tertiary" }
		}

	]
}